import { render, staticRenderFns } from "./CbsConstructor.vue?vue&type=template&id=46f94511&scoped=true"
import script from "./CbsConstructor.vue?vue&type=script&lang=js"
export * from "./CbsConstructor.vue?vue&type=script&lang=js"
import style0 from "./CbsConstructor.vue?vue&type=style&index=0&id=46f94511&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f94511",
  null
  
)

export default component.exports